import { SearchableSelect } from "@/components/shared/searchable-select";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { useMe } from "@/hooks/use-auth";
import { useWorkspaces } from "@/hooks/use-workspaces";

import type { Control, FieldValues, Path } from "react-hook-form";

// Lets canSwitchWorkspace roles (Developer/Franchisor) pick which workspace
// a new row belongs to — everyone else always creates in their own
// workspace server-side, so there's nothing to choose. Only relevant on
// create: an existing row's workspace isn't editable via this field.
// Clearable: an empty selection falls back to the actor's own workspace.
export function WorkspaceCreateField<T extends FieldValues>({
  control,
  name,
  editing,
}: {
  control: Control<T>;
  name: Path<T>;
  editing: boolean;
}) {
  const { data: me } = useMe();
  const { data: workspacesData } = useWorkspaces({ per_page: 100 });
  const workspaces = (workspacesData?.items ?? []).filter((w) => w.isActive);

  if (editing || !me?.canSwitchWorkspace) return null;

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>Workspace</FormLabel>
          <FormControl>
            <SearchableSelect
              value={field.value ?? ""}
              onChange={field.onChange}
              options={workspaces.map((w) => ({ value: w.id, label: w.name }))}
              placeholder="Pilih workspace..."
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
